module.exports = __webpack_public_path__ + "media/images/top/magazine-sample03-6614aaa6b32ef9c4d342561859310a80.jpg";